export default __webpack_public_path__ + "2215f56c117e54f47e5414c8b288eccf.png";